export default "__VITE_ASSET__BbD7ON5A__"